    import axios from './axios'

export interface NewsletterImage {
  id: number
  name: string
  size: number
  type: string
  blob_key: string
  url: string
  created_at?: string
}

export interface NewsletterImageResponse {
  success: boolean
  data?: {
    id: number
    name: string
    size: number
    type: string
    blob_key: string
    url: string
  }
  message?: string
  error?: string
}

export interface NewsletterImagesListResponse {
  success: boolean
  data?: {
    images: NewsletterImage[]
  }
  error?: string
}

export const newsletterImagesApi = {
  /**
   * Upload a newsletter image
   */
  upload: async (file: File): Promise<NewsletterImage> => {
    const formData = new FormData()
    formData.append('image', file)
    
    const response = await axios.post<NewsletterImageResponse>(
      '/newsletter_images/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    
    if (response.data.success && response.data.data) {
      return response.data.data
    }
    
    throw new Error(response.data.error || 'Failed to upload image')
  },
  
  /**
   * Get all uploaded newsletter images
   */
  list: async (): Promise<NewsletterImage[]> => {
    const response = await axios.get<NewsletterImagesListResponse>('/newsletter_images')
    
    if (response.data.success && response.data.data) {
      return response.data.data.images
    }
    
    return []
  },
  
  /**
   * Delete a newsletter image
   */
  delete: async (id: number): Promise<void> => {
    const response = await axios.delete<NewsletterImageResponse>(
      `/newsletter_images/${id}`
    )
    
    if (!response.data.success) {
      throw new Error(response.data.error || 'Failed to delete image')
    }
  }
}

